// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scoreId: __t.u64().primaryKey().name("score_id"),
  subjectKind: __t.string().name("subject_kind"),
  subjectId: __t.u64().name("subject_id"),
  axis: __t.string(),
  subAxis: __t.string().name("sub_axis"),
  delta: __t.f64(),
  confidence: __t.f64(),
  evidenceRefsJson: __t.string().name("evidence_refs_json"),
  atMicros: __t.i64().name("at_micros"),
});
